module.exports = __webpack_public_path__ + "media/assets/images/icons/client-resp-icon-mobile-6a8909bdf96f6d025b74f2f58562b4d2.svg";